import { SVGProps } from "react";

const SendEmailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_786_182)">
        <g clipPath="url(#clip1_786_182)">
          <path
            d="M0.382266 2.11163C0.548567 2.03049 0.73098 1.98777 0.916016 1.98663H8.41602C8.60105 1.98777 8.78347 2.03049 8.94977 2.11163L4.94977 5.75247C4.87191 5.82213 4.77111 5.86065 4.66664 5.86065C4.56217 5.86065 4.46137 5.82213 4.38352 5.75247L0.382266 2.11163ZM7.57852 6.98663H7.58268C7.58257 6.74529 7.65247 6.50909 7.78391 6.30667C7.91534 6.10426 8.10267 5.94431 8.32319 5.84623C8.5437 5.74814 8.78794 5.71613 9.02628 5.75406C9.26463 5.792 9.48685 5.89826 9.66602 6.05997V3.23663C9.66528 3.05061 9.62256 2.86716 9.54102 2.69997L6.20768 5.73622L7.57852 6.98663ZM-0.208984 2.69997C-0.290523 2.86716 -0.333253 3.05061 -0.333984 3.23663V8.23663C-0.333253 8.42265 -0.290523 8.6061 -0.208984 8.7733L3.12727 5.73663L-0.208984 2.69997ZM5.58602 6.29913L5.50852 6.36997C5.27747 6.57786 4.97766 6.69289 4.66685 6.69289C4.35604 6.69289 4.05623 6.57786 3.82518 6.36997L3.74602 6.29747L0.382266 9.36163C0.548634 9.44258 0.731003 9.48529 0.916016 9.48663H4.66602V8.23663C4.66602 7.90511 4.79771 7.58717 5.03213 7.35275C5.26655 7.11833 5.5845 6.98663 5.91602 6.98663H6.34102L5.58602 6.29913ZM11.211 8.77538L9.12768 6.69205C9.06943 6.63365 8.99516 6.59386 8.91428 6.57771C8.83339 6.56155 8.74953 6.56977 8.67332 6.60132C8.59711 6.63286 8.53198 6.68632 8.48617 6.75491C8.44037 6.82351 8.41595 6.90415 8.41602 6.98663V7.81997H5.91602C5.80551 7.81997 5.69953 7.86386 5.62139 7.94201C5.54325 8.02014 5.49935 8.12613 5.49935 8.23663V9.9033C5.49935 10.0138 5.54325 10.1198 5.62139 10.1979C5.69953 10.2761 5.80551 10.32 5.91602 10.32H8.41602V11.1533C8.41603 11.2357 8.44048 11.3162 8.48627 11.3847C8.53205 11.4532 8.59712 11.5066 8.67324 11.5382C8.74937 11.5697 8.83313 11.5779 8.91395 11.5619C8.99476 11.5458 9.06899 11.5061 9.12727 11.4479L11.2106 9.36455C11.2887 9.28641 11.3326 9.18045 11.3326 9.06997C11.3326 8.95948 11.2891 8.85352 11.211 8.77538Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_786_182">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.986877)"
          />
        </clipPath>
        <clipPath id="clip1_786_182">
          <rect
            width="12"
            height="9.33333"
            fill="white"
            transform="translate(-0.5 2.32013)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendEmailIcon;
